import { Component,  Input } from '@angular/core';
import publicHelpers from '../../helpers/public-helpers';
import { HomePageTextBlock } from 'globals/store/publish.data';
import { DEFAULT_BRANDING_TEXT_SIZE } from '../../helpers/constants';
import { InputEditorComponent } from '../joi-input/input-editor';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'branding-text-block',
    template: `
<input-editor *ngIf="!!brandingText" 
  [style.--quill-font-size]="(brandingText.fontSize || DEFAULT_FONT_SIZE) + 'px'"
  [style.--quill-font-color]="brandingText.color || '#000000'"
  [disabled]="true"
  [object]="brandingText" 
  [prop]="'text'"
></input-editor>
`,
    styles: [`
  :host { display: flex; }
  :host ::ng-deep input-editor .ql-editor { font-size: var(--quill-font-size); color: var(--quill-font-color); }
  .text-block { 
    color: var(--quill-font-color);
    font-size: var(--quill-font-size);
  }
`],
    standalone: true,
    imports: [InputEditorComponent, CommonModule]
})
export class BrandingTextBlockComponent {
  @Input() brandingText: HomePageTextBlock
  DEFAULT_FONT_SIZE = DEFAULT_BRANDING_TEXT_SIZE
  helpers = publicHelpers
}

